<template>
  <el-input size="mini" placeholder="请输入" :value="value" @input="input">
    <el-button
      v-if="!backend"
      slot="append"
      icon="el-icon-edit-outline"
      title="编辑"
      @click="click"
      :style="{ color: '#fff', fontSize: '18px' }"
    ></el-button>
  </el-input>
</template>

<script>
import debounce from 'lodash/debounce';

// 总投资
export default {
  props: {
    value: [String, Number],
    count: [Number, String],
    cap: [Number, String],
    base: {
      type: Number,
      default: 1
    },
    backend: Boolean
  },
  data() {
    return {};
  },
  watch: {
    cap() {
      this.computeValue();
    },
    count() {
      this.computeValue();
    }
  },
  mounted() {
    this.computeValue = debounce(this.compute, 600);
  },
  methods: {
    compute() {
      this.$emit('input', Math.round(this.cap * this.base));
    },
    input(value) {
      this.$emit('input', value);
    },
    click() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-input-group__append {
  background-color: #fff;
  border-radius: 0px;
}
</style>
